import { Outlet } from "react-router-dom";
import { PhotoboothProvider, PhotoboothModal } from "@/features/photobooth";

export default function PersonRootLayout() {
  return (
    <PhotoboothProvider>
      <Outlet />
      <PhotoboothModal />
    </PhotoboothProvider>
  );
}
